import { z } from "zod";
const providerIdentifierSchema = z.string().trim().min(1).max(1_024);
export const notificationExternalMessageReceiptSchema = z.object({
    providerMessageId: providerIdentifierSchema,
    providerConversationId: providerIdentifierSchema,
    providerThreadId: providerIdentifierSchema.optional(),
}).strict();
